import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import { AddressPropType } from '../../../../../../../prop-types/address';
import { Body } from './body';
import { Footer } from './footer';
import ModalPortal from '../../../../../../../components/modal-portal';
import { SoldToPropType } from '../../../../../../../prop-types/sold-to';

import messages from './messages';

const EditShipFromModal = ({ onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.modalTitle} />
        </ModalHeader>
        <Body />
        <Footer onClose={onClose} />
      </Modal>
    </ModalPortal>
  );
};

EditShipFromModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  shipTo: AddressPropType.isRequired,
  soldTo: SoldToPropType.isRequired,
};

export default EditShipFromModal;
